module.exports = __webpack_public_path__ + "img/trending-up.73a08a14.svg";